// extracted by mini-css-extract-plugin
export const footer = "N_bZ";
export const separator = "N_b0";
export const section = "N_b1";
export const langSection = "N_b2";
export const flag = "N_b3";